import React from 'react';
import ProjectCard from '../components/ProjectCard';

const Home = ({ language }) => {
  // 프로젝트 데이터
  const projects = [
    {
      title: "JobPilot Biz - AI-powered Job Matching Service",
      year: "2025",
      description: {
        ko: "AI를 활용한 개인화된 직업 추천과 커리어 인사이트를 제공하는 현대적인 구인구직 플랫폼입니다.",
        en: "A modern job platform leveraging AI to provide personalized job recommendations and career insights."
      },
      targets: [
        { name: "B2B", color: "#ff6b6b" },
        { name: "HR", color: "#4ecdc4" },
        { name: "Enterprise", color: "#45b7d1" }
      ],
      url: "https://jobpilotbiz.vercel.app/"
    },
    {
      title: "SmartFactory AI - Manufacturing Intelligence",
      year: "2025",
      description: {
        ko: "제조업을 위한 AI 기반 예측 유지보수 및 품질 관리 시스템입니다. 머신러닝과 IoT 센서 데이터를 활용하여 생산성 향상과 비용 절감을 실현합니다.",
        en: "AI-based predictive maintenance and quality control system for manufacturing. Utilizes machine learning and IoT sensor data to improve productivity and reduce costs."
      },
      targets: [
        { name: "Manufacturing", color: "#96ceb4" },
        { name: "Industry 4.0", color: "#feca57" },
        { name: "B2B", color: "#ff6b6b" }
      ],
      url: ""
    },
    {
      title: "HealthAI Assistant - Medical Diagnosis Support",
      year: "2025",
      description: {
        ko: "의료진을 위한 AI 기반 진단 지원 시스템입니다. 의료 영상 분석과 환자 데이터를 통합하여 정확한 진단을 돕고 치료 계획을 최적화합니다.",
        en: "AI-based diagnostic support system for healthcare professionals. Integrates medical imaging analysis and patient data to assist accurate diagnosis and optimize treatment plans."
      },
      targets: [
        { name: "Healthcare", color: "#a8e6cf" },
        { name: "Medical", color: "#ff8b94" },
        { name: "B2B", color: "#ff6b6b" }
      ],
      url: ""
    },
    {
      title: "EduTech AI - Personalized Learning Platform",
      year: "2025",
      description: {
        ko: "개인화된 학습 경험을 제공하는 AI 기반 교육 플랫폼입니다. 학생의 학습 패턴을 분석하여 맞춤형 콘텐츠와 학습 경로를 제시합니다.",
        en: "AI-based educational platform providing personalized learning experiences. Analyzes student learning patterns to offer customized content and learning paths."
      },
      targets: [
        { name: "Education", color: "#ffd93d" },
        { name: "EdTech", color: "#6c5ce7" },
        { name: "B2C", color: "#00b894" }
      ],
      url: ""
    },
    {
      title: "FinTech AI - Intelligent Banking Solutions",
      year: "2025",
      description: {
        ko: "금융 서비스를 위한 AI 기반 솔루션입니다. 사기 탐지, 위험 평가, 고객 서비스를 자동화하여 은행의 운영 효율성을 크게 향상시킵니다.",
        en: "AI-based solutions for financial services. Automates fraud detection, risk assessment, and customer service to significantly improve banking operational efficiency."
      },
      targets: [
        { name: "Finance", color: "#fd79a8" },
        { name: "FinTech", color: "#00cec9" },
        { name: "B2B", color: "#ff6b6b" }
      ],
      url: ""
    },
    {
      title: "RetailAI - Smart Commerce Platform",
      year: "2025",
      description: {
        ko: "소매업을 위한 AI 기반 상거래 플랫폼입니다. 재고 관리, 고객 행동 분석, 개인화된 마케팅을 통해 매출 증대와 고객 만족도를 향상시킵니다.",
        en: "AI-based commerce platform for retail. Enhances revenue and customer satisfaction through inventory management, customer behavior analysis, and personalized marketing."
      },
      targets: [
        { name: "Retail", color: "#fdcb6e" },
        { name: "E-commerce", color: "#e17055" },
        { name: "B2B", color: "#ff6b6b" }
      ],
      url: ""
    }
  ];

  return (
    <div className="page-container">
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">
            {language === 'ko' 
              ? 'AI-LABC의 혁신적인 프로젝트들'
              : 'Innovative Projects by AI-LABC'
            }
          </h1>
          <p className="page-subtitle">
            {language === 'ko'
              ? '최신 AI 기술을 활용한 다양한 산업 분야의 솔루션들을 확인해보세요.'
              : 'Discover solutions across various industries powered by cutting-edge AI technology.'
            }
          </p>
        </div>

        <div className="grid grid-2">
          {projects.map((project, index) => (
            <ProjectCard 
              key={index} 
              project={project} 
              language={language}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
